var jingdian = [
    // —————— 芝罘区（市中心） ——————
    [121.402115, 37.548354, '烟台山景区'],
    [121.399598, 37.536950, '所城里历史文化街区'],
    [121.406629, 37.543404, '烟台北极星钟表文化博物馆'],
    [121.400222, 37.546731, '烟台钢琴博物馆'],
    [121.393239, 37.537071, '烟台市博物馆'],
    [121.388688, 37.524406, '南山公园·动物园'],
    [121.393106, 37.511566, '塔山旅游风景区'],
    [121.385056, 37.535118, '毓璜顶公园'],
    [121.436541,37.534003, '东炮台景区'],

    // —————— 莱山区 ——————
    [121.392752, 37.374128, '烟台植物园'],
    [121.451939, 37.489080, '黄海游乐城'],
    [120.331349, 37.646039, '烟台大学海滨'],
    [120.331589, 37.661273, '渔人码头'],
    [121.451900, 37.519228, '烟台海昌鲸鲨海洋公园'],
    [121.421982, 37.462644, '凤凰湖公园'],
    [121.564040, 37.396345, '鱼鸟河公园'],

    // —————— 福山区 ——————
    [121.295180, 37.567923, '福山内夹河七大打卡地'],
    [121.283935, 37.526742, '河畔营地'],
    [121.264755, 37.464093, '隅园'],
    [121.279395, 37.487345, '烟台回里农博园'],
    [121.254578, 37.478367, '王懿荣纪念馆'],

    // —————— 牟平区 ——————
    [121.607301, 37.454380, '养马岛旅游区'],
    [121.729993, 37.291971, '昆嵛山自然保护区'],
    [121.597321, 37.442757, '龙湖葡醍海湾北中国海公园'],
    [121.597321, 37.442757, '北中国海公园海星乐园'],
    [121.730282, 37.385064, '十里杏花谷'],
    [121.600462, 37.341919, '杨子荣及牟平革命历史展览馆'],

    // —————— 蓬莱区 ——————
    [120.755853, 37.818979, '蓬莱阁景区'],
    [120.776482, 37.823696, '三仙山·八仙过海旅游景区'],
    [120.790398, 37.815407, '蓬莱欧乐堡梦幻世界'],
    [120.746810, 37.825338, '蓬莱欧乐堡海洋极地世界'],
    [120.797595, 37.786123, '平山河湿地公园'],

    // —————— 龙口市 ——————
    [120.483077, 37.567848, '龙口南山旅游景区'],
    [120.488002, 37.567583, '龙口南山游乐园'],
    [120.494338, 37.679205, '龙口动植物园'],
    [120.448146, 37.780457, '桑岛旅游景区'],
    [120.477307, 37.573256, '徐公祠'],

    // —————— 招远市 ——————
    [120.491993, 37.465634, '招远罗山黄金生态旅游区'],
    [120.370469, 37.353684, '招远架旗山游乐园'],

    // —————— 莱阳市 ——————
    [120.652904, 36.881679, '山东莱阳白垩纪国家地质公园'],
    [120.720174, 36.766213, '濯村特色农业旅游区'],
    [120.750988, 36.922319, '梨乡风情旅游区'],
    [120.815514, 36.699391, '娘娘山风景区'],

    // —————— 海阳市 ——————
    [121.207931, 36.691016, '海阳旅游度假区'],
    [121.225812, 36.846536, '招虎山国家森林公园'],
    [121.125620, 36.888222, '地雷战旅游景区'],
    [121.335101, 36.909977, '丛麻院旅游景区'],

    // —————— 栖霞市 ——————
    [120.834067, 37.318731, '牟氏庄园'],
    [120.836405, 37.342445, '太虚宫'],
    [120.827977, 37.405864, '艾山温泉康养小镇'],
    [121.367396, 37.504171, '天崮山景区'],
    [121.191494, 37.346758, '国路夼生态旅游区'],

    // —————— 长岛综试区 ——————
    [120.693820, 37.989476, '长岛南北长山旅游景区'],
    [120.693239, 37.988531, '九丈崖'],
    [120.706176, 37.989148, '月牙湾'],
    [120.627796, 37.969722, '大黑山岛景区'],

    // —————— 亲子乐园 & 儿童友好型重点景区 ——————
    [120.790398, 37.815407, '蓬莱欧乐堡梦幻世界'],
    [120.746810, 37.825338, '蓬莱欧乐堡海洋极地世界'],
    [120.488002, 37.567583, '龙口南山游乐园'],
    [120.370469, 37.353684, '招远架旗山游乐园'],
    [121.597321, 37.442757, '北中国海公园海星乐园'],
    [121.286132, 37.557911, '福山内夹河河畔营地（亲子露营+风筝展）'],
    [121.370177, 37.463593, '爱设计·南仓1号亲子乐园'],
    [121.366405, 37.508726, '南尧新都汇儿童乐园'],
    [120.652904, 36.881679, '莱阳白垩纪国家地质公园（恐龙化石挖掘体验）']
];

var yantai = [
    {
        name: '景点',
        group: 'base',
        list: jingdian,
        show: true,
        color: 'red'
    }
]


export default yantai